const URL = `${window.location.origin}/api`;
// const URL = 'http://localhost:8000/api';

// APP - Software version and copyright
// API - Base URL for the backend
// EVENTS - Events Inifinite scroll configuration - MUST MATCH BACKEND!

var obvmConfig = {
	APP: {
		VERSION: "2.0.4.2",
		VERSION_DATE: "1/2026",
		COPYRIGHT_YEAR: "2026",
	},
	API: {
		BASE_URL: URL,
	},
	EVENTS: {
		EVENTS_PER_PAGE: 100,
	},
};

export default obvmConfig;
